export default __webpack_public_path__ + "static/media/photo--sm--blitz-1.cd41598d.jpg";